import { render, staticRenderFns } from "./ModalEditBundle.vue?vue&type=template&id=58e8d208"
import script from "./ModalEditBundle.vue?vue&type=script&lang=js"
export * from "./ModalEditBundle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports